import React, { useState } from "react";
import { Container } from "reactstrap";
import PageHeaderActions from "Components/Common/PageHeaderActions";
import ClientList from "Components/Client/ClientList";

const Clients = () => {
  const [showManageClientModal, setShowManageClientModal] =
    useState<boolean>(false);

  document.title = "Clients | EaziQuote";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="gap-3 d-flex flex-column">
            <PageHeaderActions
              title="Clients"
              subtitle="Manage all your clients"
              actions={[
                {
                  label: "Add Client",
                  onClick: () => {
                    setShowManageClientModal(true);
                  },
                  leftIcon: <i className="ri-add-fill me-1 align-bottom "></i>,
                },
              ]}
            />
            <ClientList
              showManageClientModal={showManageClientModal}
              setShowManageClientModal={setShowManageClientModal}
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Clients;
